/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$( document ).ready(function() {
  if($('.template-index').length > 0){
    if(document.referrer == "https://uk.ahmadtea.com/challenge"){
      location.href = '/account';
    }
  }
  
//   MegaMenu
  let megaMenuGrandChildLiA = $(".MegaMenu__Inner").find("ul>li.Linklist__Item>a.Link.Link--secondary");
  $(megaMenuGrandChildLiA).mouseover(function(){
    const data_short_desc = $(this).data("desc");
    const data_image = $(this).data("img-src");
    const $href = $(this).attr("href");
    //     console.log($href);
    //     console.log(data_short_desc);
    if($href != undefined){
      $(this).closest(".MegaMenu").find(".MegaMenu__Item.right_megamenu").find("span").parent("a").attr({"href":$href});
    }
    if(data_short_desc != undefined){
      $(this).closest(".MegaMenu").find(".right_menu_inner>.right_menu_text").find("p").first().text(data_short_desc);
    }
    if(data_image != undefined){
      $(this).closest(".MegaMenu").find(".right_menu_inner>.right_menu_text").first()
      .css({
        "background":`url(${data_image})`
      }).children("a").find(".right_menu_text_inner").html(`<img src="${data_image}">`);
    }
  });
  
  if($(window).width() < 768){
    $('.AnnouncementBar__Wrapper').slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
    });
  }

  $('.featured-product-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  $('.Product_Slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    fade: true,
    asNavFor: '.Product__Slides__thumb'
  });
  $('.Product__Slides__thumb').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.Product_Slideshow',
    dots: false,
    arrows: true,
    focusOnSelect: true
  });

  $(window).scroll(function(){
    if ($(window).scrollTop() >= 100) {
      $('.product-form-bar').addClass('fixed-bar');
    }
    else {
      $('.product-form-bar').removeClass('fixed-bar');
    }
  });
  
  $('.cureency-dropdown-div').on('click', function(){
    $(this).parent().toggleClass('active');
});

});

// Set Cookie
function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$(".close-icon").click(function(){
  setCookie("popnote","close", 30);
  $(".faq-note").addClass("note-close");
});    

var user=getCookie("popnote");
if (user){
  $(".faq-note").addClass("note-close");
}

$(document).ready(function(){
  
  $('.qtyplus').click(function(e){
    e.preventDefault();

    var $this = $(this),
        $input = $this.prev('input'),
        newValue = parseInt($input.val())+1;
    $input.val(newValue).focus();
    $this.closest('.cart__row').find('.cart__price').find('input').val(newValue);
  });

  $(".qtyminus").click(function(e) {
    e.preventDefault();

    var $this = $(this),
        $input = $this.next('input'),
        newValue = parseInt($input.val())-1;

    if(newValue<0){	
      $input.val(0).focus();      
    } else {
      $input.val(newValue).focus();
      $this.closest('.cart__row').find('.cart__price').find('input').val(newValue);
    }
  });  

});

/* check weather filter is blank or not (remove leftside blank space) */
$(document).ready(function(){
  
  var isALARendered;
  function ALAcheck() {    
    isALARendered = setInterval(function () {
      customALA()
    }, 800);
  }
  ALAcheck();
  
  function customALA() {
    if($('.CollectionInner__Sidebar .boost-pfs-filter-options-wrapper').length > 0) {
      clearInterval(isALARendered);
      if( $('.CollectionInner__Sidebar .boost-pfs-filter-option.boost-pfs-filter-option-list').length < 1 ){
        $('.CollectionInner__Sidebar').addClass('hide');
        $('.CollectionToolbar__Item--filter').addClass('hide');
      }    
    }    
  }

});


$(window).on('load',function(){
  if (window.location.href.indexOf("#recover") >= 0) {
    $('.Form__Item').each(function() {
      if($(this).find('.Form__ItemHelp').attr('data-action') == 'toggle-recover-form'){
        $(this).find('.Form__ItemHelp').trigger('click');
      }
    });
  }
});

$(document).ready(function(){
 var items_added = 0;
 var pusharr = [];
 var max_mix_allowed = parseInt($(".mixed-max").data("mix_select_limit"));
 
  console.log(max_mix_allowed);
  
    $("[data-action='new-increase-quantity']").on('click', function(e) {
      
      if(items_added < max_mix_allowed){
        $(this).prev().val(parseInt($(this).prev().val()) + 1);
        var teasku = $(this).prev().attr('data-sku');
      	var title = $(this).prev().attr('data-pro-title')+" - "+teasku;
      	pusharr.push({'title':title});
        items_added = items_added + 1;
        bundleLogic(pusharr);
//         console.log(pusharr);
      }
    });

    $("[data-action='new-decrease-quantity']").on('click', function(e) {
      
     $(this).next().val( Math.max(parseInt($(this).next().val()) - 1, 0));
      
      var title = $(this).next().attr('data-pro-title');
      var qty = parseInt($(this).next().val());
      
      if(qty < 1){
       $('.mix-pro-properties input').each(function() {
          var pro_title = $(this).val();
          var pro_title_split = pro_title.split("x");
          if(pro_title_split[0] == title){
          	$(this).val("");
            var index = pusharr.findIndex(function(product) {
                return product.title == title
              });
           pusharr.splice(index,1);
		  }
        });
        items_added = 0;
      }else{
      items_added = items_added - 1;
//       countitems();
//       console.log(pusharr); 
        
      }
      bundleLogic(pusharr);
    });

function bundleLogic(bundleObj) {
  var countindex = max_mix_allowed - items_added;
//   console.log(items_added)
  if(countindex == 0){
     
    $('.ProductForm__AddToCart').addClass('added-mix').removeAttr('disabled');
    $('.ProductForm__AddToCart').attr('data-action','add-to-cart');
      //     $('.ProductForm__AddToCart span').html('<span>Add To Cart</span>');
    $("span .currently_added").text(items_added); 
    $(".mixedbag-error span.currently_added").text(items_added);
    console.log(items_added+" items added");
    console.log(countindex+" items remaining");
    
  } else {
     $('.ProductForm__AddToCart').removeClass('added-mix').attr('disabled','disabled');
   	 $('.ProductForm__AddToCart').removeAttr('data-action');
        //     $('.ProductForm__AddToCart span').html('Pick <span class="pick-count">'+countindex+'</span> more');
	$("span.currently_added").text(items_added);	
    $(".mixedbag-error span.currently_added").text(items_added);	
    console.log(items_added+" items added");
    console.log(countindex+" items remaining");
    
  }
  
  for(var i=0;i < max_mix_allowed;i++){
    var idx = i+1;
    if(bundleObj[i]){
      
      $('[name="properties[_product-'+idx+']"]').val($.trim(bundleObj[i].title));
      $('.pick-count').text(countindex);
    } else {
      $('[name="properties[_product-'+idx+']"]').val('');
    }
  }
  
}
  
$("ul.mix-properties").each(function () {
  
  var liText = '', liList = $(this).find('li'), listForRemove = [];
  $(liList).each(function () {
      var text = $(this).text();
    if (liText.indexOf('|'+ text + '|') == -1)
      liText += '|'+ text + '|';
    else
      listForRemove.push($(this));
  });

  $(listForRemove).each(function () { $(this).remove(); });
});
$("ul.mix-properties").removeClass("hide"); 
});

$(document).ready(function(){
  $('.blog_slider').slick({
    centerMode: true,
    centerPadding: '150px',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });
});


/*sticky Header*/

/*jQuery(window).bind('scroll', function () {
    if (jQuery(window).scrollTop() > 28) {
        jQuery('multi-title').addClass('sticky_header');
    } else {
        jQuery('multi-title').removeClass('sticky_header');
    }
});*/
if( $('.tea-journey-main .multi-title-main').length > 0 ){
$(document).scroll(function() {
  var fixmeTop = $('#shopify-section-journey-sec1').offset().top;       // get initial position of the element
  var currentScroll = $(window).scrollTop(); // get current position  
  if (currentScroll >= fixmeTop) {      
    $('.multi-title-main').addClass("sticky_header-journey");
  } else {
    $('.multi-title-main').removeClass("sticky_header-journey");
  }
});
}

$(".scroll").click(function (event) {
        //prevent the default action for the click event  
        event.preventDefault();
        //get the full url - like mysitecom/index.htm#home  
        var full_url = this.href;
        //split the url by # and get the anchor target name - home in mysitecom/index.htm#home  
        var parts = full_url.split("#");
        var trgt = parts[1];
        //get the top offset of the target anchor  
        var target_offset = $("#" + trgt).offset();
        var target_top = target_offset.top;
        //goto that anchor by setting the body scroll top to anchor top  
        $('html, body').animate({scrollTop: target_top -50}, 1000);
    });




// cookie policy bar 
$(document).ready(function(){
  $(".cookie-bar").find("#cookie-allow").click(function(){
    localStorage.setItem("cookies", "Allowed");
    $(".cookie-bar").hide();
  });
});

if (typeof(Storage) !== "undefined") {
  var cookieAllowed = localStorage.getItem("cookies");
  if (cookieAllowed == "Allowed"){
    $(".cookie-bar").hide();
  }else {
    $(".cookie-bar").show();
  }
}


// $('.Collapsible__Button').click(function(){ 
//   $('.Collapsible__Button').not(this).removeClass('active');
//   $('.Collapsible__Button').next().not($(this).next()).removeClass('active');
  
//   $(this).toggleClass('active');
//   $(this).next().toggleClass('active');
//   if($(this).hasClass('active')) {
//     $(this).siblings().show();
//   } else {
//     $(this).siblings().hide();
//   }
// });


/* Slider autoplay  next in 6 sec */

// $(document).ready(function(){  
//   var auto_slide = $('.Slideshow__Carousel').attr('data-auto-slide');
//   console.log('auto_slide',auto_slide);  
//   if (auto_slide > 1){    
//     setInterval(function(){
//       var $carousel = $('.Slideshow__Carousel');
//       var flkty = $carousel.flickity({autoPlay: auto_slide});
//       //console.log('call ==> auto_slide',auto_slide);      
//       $('.Slideshow__Carousel.Carousel').flickity( 'next', true, false );
//     }, auto_slide);    
//   }
// });
$(document).ready(function(){
  if( $('.Slideshow__Carousel').length > 0 ){
  var auto_slide = $('.Slideshow__Carousel').attr('data-auto-slide');
  console.log('auto_slide',auto_slide);

  var $carousel = $('.Slideshow__Carousel');
  var flkty = $carousel.flickity();
  
  var interval = ''; var flg = 0;
  
  function slider_flk(){
    if (auto_slide > 1){
	  if (flg == 0){
        var flkty = $carousel.flickity({autoPlay: auto_slide});

        interval = setInterval(function(){
          console.log('change==',auto_slide);
          $('.Slideshow__Carousel.Carousel').flickity( 'next', true, false );
        }, auto_slide);
      }
    }
  }
  slider_flk();
  
  if ($(window).width() <= 991) {
//     var slider_btn = $('.flickity-prev-next-button');
//     slider_btn.click(function(){
//       console.log('stop',interval);
//       clearInterval(interval);
//       flg = 1;
//       $carousel.flickity({autoPlay: false});
//     });
    
//     $('.flickity-prev-next-button.next').on( 'click', '.next', function() {
//       console.log('stop',interval);
//     });
    
    
    
  }
  
//   $('.flickity-prev-next-button.next').on( 'click', '.next', function() {
//     console.log('stop',interval);
//   });
  
  $(document).on('click', '.flickity-prev-next-button', function (e) {
    //console.log('stop1');
    
    if ($(window).width() <= 991) {
      var slider_btn = $('.flickity-prev-next-button');      
     // console.log('stop',interval);
      clearInterval(interval);
      flg = 1;
      $carousel.flickity({autoPlay: false});
    }
  });
  $carousel.on( 'dragEnd.flickity', function( event, pointer ) {
  	if ($(window).width() <= 991) {
      var slider_btn = $('.flickity-prev-next-button');      
     // console.log('Drag-stop',interval);
      clearInterval(interval);
      flg = 1;
      $carousel.flickity({autoPlay: false});
    }
  });
  
  
  if ($(window).width() > 991) {
    var slider_hover = $('.Slideshow__Carousel');
    slider_hover.mouseenter(function(){
      clearInterval(interval);
      //console.log('hovered');
    });  
    slider_hover.mouseleave(function(){
      slider_flk();
      //console.log('Leaved');
    });
  }
  
  
  
//   jQuery.fn.simulateClick = function() {
//     return this.each(function() {
//       if ('createEvent' in document) {
//         var doc = this.ownerDocument,
//             evt = doc.createEvent('MouseEvents');
//         evt.initMouseEvent('click', true, true, doc.defaultView, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
//         this.dispatchEvent(evt);
//       } else {
//         this.click(); // IE Boss! 
//       } 
//     }); 
//   }
  
//   jQuery(document).ready(function() {
//     jQuery('.flickity-prev-next-button.next').on('click', function() {
//       jQuery('.flickity-prev-next-button.next').simulateClick('click');
//       console.log('clk');
//     });
//   });
  

  
  
  
  }
  
  if( $('.ProductForm__AddToCart2').length > 0  ){
    $('.ProductForm__AddToCart2').click(function(e){
      e.preventDefault();    
      var data = $(this).closest('.FeaturedProduct__Info').find('form').serialize();
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      $.ajax({
        type: 'post',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(res) {
          //document.dispatchEvent(new CustomEvent('theme:loading:end'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          $('.Header__Icon[data-drawer-id="sidebar-cart"]')[0].click();
        },
        error: function(err) {
           document.dispatchEvent(new CustomEvent('theme:loading:end'));
           $(this).removeAttr('disabled');
          console.log(err.responseJSON.description);
        }

      });

    });
  }
  
  
});
function continueShop(){
  var element = document.getElementById("popup_1");
  element.classList.remove("show");
}
function checkoutSub(){
  var element = document.getElementById("popup_1");
  element.classList.add("show");
}  